import css from 'styled-jsx/css';
import { colors } from 'components/styles/variables';

export const styles = css`
  .srp-search-filters-sidebar {
    background: ${colors.G1};
    padding: 16px;
    display: flex;
    flex-direction: column;
    border-radius: 16px;
    margin-bottom: 40px;
    max-width: 330px;
  }
`;
